import { forwardRef } from 'react'
import { useShallow } from 'zustand/react/shallow'

import useActiveFilterStore from '../../../stores/marketplace/active-filter'

interface LocationInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  className?: string
}

const LocationInput = forwardRef<HTMLInputElement, LocationInputProps>(
  ({ value, onChange, placeholder = 'Search location', className, ...props }, ref) => {
    const { activeDropdown, setActiveDropdown } = useActiveFilterStore(
      useShallow((state) => ({
        activeDropdown: state.activeDropdown,
        setActiveDropdown: state.setActiveDropdown,
      })),
    )

    return (
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        autoComplete="off"
        data-lpignore="true"
        data-form-type="other"
        role="combobox"
        aria-controls="location-predictions"
        aria-autocomplete="list"
        onFocus={(e) => {
          e.stopPropagation()
          e.preventDefault()
          if (activeDropdown !== 'where') {
            setTimeout(() => {
              setActiveDropdown('where')
            }, 100)
          }
        }}
        {...props}
      />
    )
  },
)

LocationInput.displayName = 'LocationInput'

export default LocationInput
